import { Component, Input } from '@angular/core'
import { IconNamesEnum, NgxBootstrapIconsModule } from 'ngx-bootstrap-icons'

import { Dictionary } from "src/app/shared/components/filtering-search-component-base/filtering-search-types"
import { expandCollapse, openClose } from '../../animations/open-close-animations'
import { PhoneFormatPipe } from '../../pipes/phone-format.pipe'
import { LinkedInComponent } from '../linked-in/linked-in.component'
import { InstrumentViewComponent } from '../instrument-view/instrument-view.component'
import { NgbTooltip, NgbCollapse, NgbPopover } from '@ng-bootstrap/ng-bootstrap'
import { NgTemplateOutlet, CurrencyPipe, DatePipe, DecimalPipe } from '@angular/common'
import { CdkTableModule } from '@angular/cdk/table'

@Component({
    animations: [
        openClose,
        expandCollapse,
    ],
    selector: 'prepost-capital-structure',
    templateUrl: './prepost-capital-structure.component.html',
    styleUrls: ['./prepost-capital-structure.component.scss'],
    imports: [
        CdkTableModule,
        NgxBootstrapIconsModule,
        NgTemplateOutlet,
        NgbTooltip,
        InstrumentViewComponent,
        NgbCollapse,
        LinkedInComponent,
        NgbPopover,
        CurrencyPipe,
        DatePipe,
        PhoneFormatPipe,
        DecimalPipe
    ]
})
export class PrePostCapitalStructureComponent {

  public iconNames = IconNamesEnum
  public isExpanded: Dictionary<boolean> = {}

  @Input() structure: any
  @Input() columns: string[] = []
  @Input() expandAll = false
  @Input() classesLookup: Dictionary<any> = {}
  @Input() instrumentIDLookup: Dictionary<any> = {}
  @Input('expandID') set expandID(id:string) {
    if (id?.length > 0) {
      this.isExpanded[id] = true
    }
  }


  getLinkedInHandle(str: string): string {
    try {
      const url = new URL(str)
      return url.pathname.replace('/in/', '').replace('/', '')
    } catch (e) {
      return ''
    }
  }
  trimURL(url: string) {
    let result = url.split('#')[0]
    result = result.split('?')[0]
    return result
  }

}
